import React, { useState, useEffect } from 'react'
import { append, equals, without } from 'ramda'

const goToSectionNew = (groupId, projectId) => {
  const search = projectId ? `?project_id=${projectId}` : ''
  window.location.href = `/groups/${groupId}/sections/new${search}`
}

const Section = ({ data, selected, onClick }) => {
  const { id, name, students } = data
  return (
    <div className="section-option">
      <input
        type="checkbox"
        id={`section-${id}`}
        name="sections"
        checked={selected}
      />
      <label htmlFor={`section-${id}`} onClick={onClick}>
        <strong>{name}</strong>
        <br />
        <small>{students.length} Students</small>
      </label>
    </div>
  )
}

const SectionPicker = ({
  group,
  projectId,
  selected: initialSelected,
  onSave,
  liveQuestionCount,
}) => {
  const [selected, setSelected] = useState(initialSelected)
  const [showWarning, setShowWarning] = useState(false)

  useEffect(() => {
    setSelected([])
  }, [group])

  const isSelected = (section) => {
    return selected.includes(section.id)
  }

  const toggleSelected = (section) => {
    const showWarning = liveQuestionCount > 0

    if (isSelected(section)) {
      setSelected(without([section.id], selected))
      setShowWarning(showWarning)
    } else {
      setSelected(append(section.id, selected))
      setShowWarning(false)
    }
  }

  const handleSave = () => {
    onSave(selected)
  }

  const activeSections = group.sections?.filter((s) => !s.archived)

  return (
    <div className="section-picker">
      <h2>Pick Sections</h2>
      {showWarning && (
        <div className="warning">
          <i className="material-icons">Error</i>
          <span>
            <span style={{ fontWeight: 'bold', fontSize: '1.2em' }}>
              Warning
            </span>
            <br />
            Are you sure you want to remove this section of students?
            <br />
            They will lose access to the project.
            <br />
            To cancel, click the "cancel" link (top right).
          </span>
        </div>
      )}
      <div className="sections">
        {activeSections?.map((s) => (
          <Section
            key={s.id}
            data={s}
            selected={isSelected(s)}
            onClick={() => toggleSelected(s)}
          />
        ))}
      </div>
      <a
        className="add-new"
        onClick={() => goToSectionNew(group.id, projectId)}
      >
        <i className="material-icons">add_circle</i>
        Add New Section
      </a>
      <button onClick={handleSave}>Save &amp; Close</button>
    </div>
  )
}

export default SectionPicker
